import { Link } from "react-router-dom";
import {
  FaCar,
  FaShuttleVan,
  FaTruckPickup,
  FaUsers,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaArrowRight,
} from "react-icons/fa";
import { getSuburbBySlug, getSuburbPath } from "../data/suburbs";

const SERVICE_AREAS = [
  { name: "Huntingdale", slug: "huntingdale" },
  { name: "Clayton", slug: "clayton" },
  { name: "Oakleigh", slug: "oakleigh" },
  { name: "Chadstone", slug: "chadstone" },
  { name: "Springvale", slug: "springvale" },
  { name: "Dandenong", slug: null },
  { name: "Moorabbin", slug: "moorabbin" },
  { name: "Malvern", slug: "malvern" },
  { name: "Caulfield", slug: null },
];

const VEHICLE_TYPES = [
  {
    icon: FaCar,
    title: "Cars",
    description: "Compact, budget and European options for everyday driving.",
  },
  {
    icon: FaShuttleVan,
    title: "Vans",
    description: "Ideal for moving, deliveries and extra cargo space.",
  },
  {
    icon: FaTruckPickup,
    title: "Utes",
    description: "Reliable 1-tonne utes for work, trade and weekend jobs.",
  },
  {
    icon: FaUsers,
    title: "7 Seaters",
    description: "Room for the whole family, groups and airport trips.",
  },
];

const HIRE_OPTIONS = [
  "Weekend & short term hire",
  "Long term rental",
  "Van for moving",
  "Ute for work",
];

function LocalHireSection() {
  const scrollToQuote = () => {
    const quoteSection = document.querySelector("#booking-section");
    if (quoteSection) {
      quoteSection.scrollIntoView({ behavior: "smooth" });
      return;
    }
    window.location.assign("/request-quote");
  };

  return (
    <section className='local-hire-section' aria-labelledby='local-hire-heading'>
      <div className='container'>
        <div className='local-hire-content'>
          <header className='local-hire-header'>
            <h3 className='local-hire-header__eyebrow'>About EZ Car Rentals</h3>
            <h2 id='local-hire-heading'>
              Local Vehicle Hire in{" "}
              <span className='yellow-text'>South-East Melbourne</span>
            </h2>
          </header>

          <div className='local-hire-main'>
            <div className='local-hire-intro'>
              <p>
                EZ Car Rentals is a local car rental company based in Huntingdale,
                Melbourne. We offer affordable cars, vans, utes and 7 seater
                vehicles for short term and long term hire. Based in South-East of
                Melbourne, we service customers from all parts of Melbourne
                including Clayton, Oakleigh, Chadstone, Springvale, Dandenong,
                Moorabbin, Malvern, Caulfield and more!
              </p>
              <p>
                Whether you need a car for the weekend, a van for moving, a ute
                for work, or a long term rental while your car is being repaired,
                EZ Car Rentals provides flexible and budget-friendly vehicle hire
                options.
              </p>

              <ul className='local-hire-options'>
                {HIRE_OPTIONS.map((option) => (
                  <li key={option}>{option}</li>
                ))}
              </ul>

              <div className='local-hire-cta'>
                <button
                  type='button'
                  className='local-hire-cta__primary'
                  onClick={scrollToQuote}
                >
                  Request a Quote <FaArrowRight aria-hidden='true' />
                </button>
                <a href='tel:0400920512' className='local-hire-cta__secondary'>
                  <FaPhoneAlt aria-hidden='true' /> 0400 920 512
                </a>
              </div>
            </div>

            <div className='local-hire-vehicles' aria-label='Vehicle types'>
              {VEHICLE_TYPES.map(({ icon: Icon, title, description }) => (
                <article className='local-hire-vehicle-card' key={title}>
                  <div
                    className='local-hire-vehicle-card__icon'
                    aria-hidden='true'
                  >
                    <Icon />
                  </div>
                  <div className='local-hire-vehicle-card__body'>
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className='local-hire-areas'>
            <h3>
              <FaMapMarkerAlt aria-hidden='true' />
              <span>Areas we serve across Melbourne</span>
            </h3>
            <div className='local-hire-areas__tags'>
              {SERVICE_AREAS.map(({ name, slug }) => {
                const suburb = slug ? getSuburbBySlug(slug) : null;

                if (suburb) {
                  return (
                    <Link
                      key={name}
                      to={getSuburbPath(suburb.slug)}
                      className='local-hire-area-tag'
                    >
                      {name}
                    </Link>
                  );
                }

                return (
                  <span
                    key={name}
                    className='local-hire-area-tag local-hire-area-tag--plain'
                  >
                    {name}
                  </span>
                );
              })}
              <Link
                to='/suburbs'
                className='local-hire-area-tag local-hire-area-tag--more'
              >
                View all suburbs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LocalHireSection;
